/**
 * Limpia los warn de ejecución de la consola, aun se ven en eslint
 * @param {bool} active true si está activo
 * Se pierde el trace de los otros warning
 */
const cleanConsole = (active) => {
  if (active) {
    // eslint-disable-next-line no-console
    const originalWarn = console.warn;
    // eslint-disable-next-line no-console
    console.warn = (...args) => {
      const [firstArg] = args;
      const isExhaustiveDepsWarning = typeof firstArg === 'string'
        && firstArg.includes('React Hook')
        && firstArg.includes('exhaustive-deps');

      if (!isExhaustiveDepsWarning) {
        originalWarn.apply(console, args);
      }
    };
  }
};

module.exports = {
  cleanConsole,
};
